import type { FieldError, FieldErrorsImpl, Merge, UseFormRegister } from 'react-hook-form';
import styles from '../Form.module.css';

const InputField = ({
  label,
  name,
  id,
  type,
  error,
  placeholder,
  customClassName,
  defaultValue,
  disabled,
  register,
  min,
}: {
  label?: string | number;
  name: string;
  id?: string;
  type: string;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  placeholder?: string;
  customClassName?: string;
  defaultValue?: any;
  disabled?: boolean;
  register: UseFormRegister<any>;
  min?: string | number;
}) => (
  <div className={`${customClassName}`}>
    <label className={'leading-7 block text-sm font-medium text-neutralColor-medium'} htmlFor={id}>
      {label}
    </label>
    <input
      className={`${error ? styles['form-input-error'] : styles['form-input-normal']}`}
      type={type}
      id={id}
      placeholder={placeholder}
      autoComplete={name}
      defaultValue={defaultValue}
      disabled={disabled}
      min={min}
      {...register(name)}
    />
    {error && <p className='text-red-600 text-sm mt-1'>{`${error}`}</p>}
  </div>
);

export default InputField;
